
import "./drop_down.css";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa";




const DropDownButton = ({isdropdown,setisdropdown,title,selections}) => {
  
    return (
        <div className="drop_down_whole_container">

            <button onClick={() =>setisdropdown(!isdropdown)} className="drop_down_button">
                <span>{title}</span>
                {isdropdown ? <FaAngleUp /> : <FaAngleDown />}
                </button>
        </div>
    );
  };
  
  export default DropDownButton;